import { Dispatch } from 'react';

import { ReportRequestAction } from '../model/reducer';
import { FieldErrors, ReportRequestState } from '../model/types';

export interface StepProps {
  state: ReportRequestState;
  dispatch: Dispatch<ReportRequestAction>;
  /** Only populated once the user has tried to submit the form. */
  errors: FieldErrors;
}

/** Row level errors (`prefix.<n>`) keyed by row index, for list editors. */
export const rowErrors = (errors: FieldErrors, prefix: string): Record<number, string> =>
  Object.entries(errors).reduce<Record<number, string>>((acc, [key, message]) => {
    const match = key.match(new RegExp(`^${prefix.replace('.', '\\.')}\\.(\\d+)$`));
    if (match) acc[Number(match[1])] = message;
    return acc;
  }, {});
